import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../firebaseConfig';
import { sanitizeFirestoreData } from '../components/reports/ReportShared';

export async function recordGeneratedReport(organizationId: string | undefined, resultData: any, title: string, type: string, clientId?: string | null) {
    if (!organizationId || !auth.currentUser || !resultData)
        return;
    try {
        await addDoc(collection(db, 'generated_reports'), {
            organizationId,
            clientId: clientId || null,
            title,
            type,
            resultData: sanitizeFirestoreData(resultData),
            timestamp: serverTimestamp(),
            userEmail: auth.currentUser.email,
            userName: auth.currentUser.displayName || auth.currentUser.email,
        });
    } catch (error) {
        console.error('Could not record generated report:', error);
    }
}
